<app-cadastro [personalizado]="true"></app-cadastro>